module.exports = __webpack_public_path__ + "img/turtles.c78e3f7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/turtles.jpg
// module id = VPoB
// module chunks = 0